import React, { useState, useEffect, useMemo } from "react";
import { getStaffMembers } from "../../services/users.js";
import { format } from "date-fns";
import UserProfileSummary from "./UserProfileSummary.js";
import CreateStaff from "../modals/CreateStaffModal.js";
import ReusableTable from "../ReusableTable.js";
import { useSearchParams } from "react-router-dom";
import Icon from "../Icon.js";

export const StaffMembers = () => {
  const [usersList, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedUser, setSelectedUser] = useState(null);

  // Get initial state from URL (defaults if not set)
  const pageIndex = useMemo(() => {
    const pageParam = searchParams.get("page");
    const page = parseInt(pageParam, 10);
    return isNaN(page) ? 0 : Math.max(0, page);
  }, [searchParams]);
  const expandedRows = JSON.parse(searchParams.get("expanded") || "{}");
  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const { data } = await getStaffMembers();
      setUsers(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  const editUser = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const columns = useMemo(
    () => [
      { accessorKey: "firstName", header: "First Name" },
      { accessorKey: "lastName", header: "Last Name" },
      { accessorKey: "telephoneNumber", header: "Phone Number" },
      { accessorKey: "emailAddress", header: "Email" },
      { accessorKey: "ethnicity", header: "Ethnicity" },
      { accessorKey: "gender", header: "Gender" },
      {
        accessorKey: "startDate",
        header: "Start Date",
        cell: ({ row }) =>
          format(new Date(row.original.startDate), "dd/MM/yyyy"),
      },
      {
        accessorKey: "staffId",
        header: "Actions",
        cell: ({ row }) => (
          <Icon
            id="edit"
            size={14}
            className="edit__icon"
            onClick={() => editUser(row.original)}
          />
        ),
      },
    ],
    []
  );

  const updatePage = (newPageIndex) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", newPageIndex);
      return params;
    });
  };

  const updateExpandedRows = (rowId, isExpanded) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      const expanded = JSON.parse(params.get("expanded") || "{}");
      if (isExpanded) expanded[rowId] = true;
      else delete expanded[rowId];
      params.set("expanded", JSON.stringify(expanded));
      return params;
    });
  };

  return (
    <div>
      {/* <div className="user__top">
        <button
          className="btn btn__primary"
          onClick={() => {
            setIsModalOpen(true);
            setSelectedUser(null);
          }}
        >
          + Add team member
        </button>
      </div> */}
      <ReusableTable
        data={usersList}
        columns={columns}
        isLoading={isLoading}
        enableMasterDetails
        renderDetails={(user) => (
          <UserProfileSummary
            user={user}
            detailsUrl="/team-member/"
            userType="staff"
            editStaff={() => editUser(user)}
          />
        )}
        pageIndex={pageIndex}
        onPageChange={updatePage}
        expandedRows={expandedRows}
        onRowExpandChange={updateExpandedRows}
      />
      {isModalOpen && (
        <CreateStaff
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          reloadUsers={() => fetchUsers()}
          user={selectedUser}
        />
      )}
    </div>
  );
};
